import { ICreateParcelModel } from "../i-create-parcel-model"
import { CreateParcelModelOption } from "./create-parcel-model-option"
import { DpdProductVariant } from "../dpd-product/dpd-product-variant"
import * as _ from "lodash"

export class CreateParcelModelOptions {
    private readonly createParcelModel: ICreateParcelModel

    readonly returnOfDocument: CreateParcelModelOption
    readonly deskDelivery: CreateParcelModelOption
    readonly idCheck: CreateParcelModelOption
    readonly predict: CreateParcelModelOption
    readonly createParcelModelOptions: CreateParcelModelOption[] = []

    constructor(createParcelModel?: ICreateParcelModel) {
        this.createParcelModel = createParcelModel

        this.returnOfDocument = new CreateParcelModelOption(this, "returnOfDocument")
        this.deskDelivery = new CreateParcelModelOption(this, "deskDelivery")
        this.idCheck = new CreateParcelModelOption(this, "idCheck")
        this.predict = new CreateParcelModelOption(this, "predict")

        this.createParcelModelOptions.push(this.returnOfDocument)
        this.createParcelModelOptions.push(this.deskDelivery)
        this.createParcelModelOptions.push(this.idCheck)
        this.createParcelModelOptions.push(this.predict)
    }

    initWithProductVariant(dpdProductVariant: DpdProductVariant) {
        _.forEach(this.createParcelModelOptions, createParcelModelOption => {
            createParcelModelOption.initFrom(dpdProductVariant)
        })
        // this.handleProductOptionsWithExpressions()
    }

    // handleProductOptionsWithExpressions() {
    //     _.forEach(this.createParcelModelOptions, createParcelModelOption => createParcelModelOption.contextChanged())
    // }

    get context(): any {
        return _.reduce(this.createParcelModelOptions, (accumulator, createParcelModelOption) => {
            accumulator[createParcelModelOption.name] = createParcelModelOption.value
            return accumulator
        }, {} as any)
    }

    // evaluateExpression<T>(expression: string): T {
    //     return this.createParcelModel.evaluateExpression(expression)
    // }
}
